import { computed, defineComponent } from '@vue/composition-api';
import DpIcon from '../icon/Icon.vue';
import DpTooltip from '../modal/Tooltip.vue';
export default defineComponent({
    name: 'DpVirtualOption',
    components: {
        DpIcon,
        DpTooltip,
    },
    props: {
        label: { type: null, required: true },
        val: { type: null, required: true },
        icon: { type: String, default: null },
        selected: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        focused: { type: Boolean, default: false },
        disabledTooltip: { type: String, default: null },
        editable: { type: Boolean, default: false },
        tooltip: { type: String, default: null },
        hideTitle: { type: Boolean, default: false },
    },
    setup(props, { emit }) {
        const { disabled, disabledTooltip, tooltip, val, } = props;
        const calculatedTooltip = computed(() => {
            if (disabled) {
                return disabledTooltip;
            }
            return tooltip || null;
        });
        const selectOption = () => {
            emit('select', props);
        };
        const edit = () => {
            emit('edit', val);
        };
        return {
            calculatedTooltip,
            selectOption,
            edit,
        };
    },
});
